import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'

import Component from '../components/Yours'
import headerActions from '../../header/actions/header'
import shareActions from '../../shared/actions/share'
import depositActions from '../../depositV2/actions/deposit'
import actions from '../actions/yours'
import loginActions from '../../login/actions/login'
import rentActions from '../../remove/actions/start'
import costsActions from '../actions/costs'

class Container extends React.Component {

  constructor(props) {
    super(props)
    props.getCosts()
    if (props.isLoggedIn === true) {
      props.initialSearch()
    }
  }

  render() {
    return <Component {...this.props}/>
  }
}

Container.propTypes = {
  initialSearch: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
}

const mapStateToProps = state => {
  const data = state.ui.yours.yours
  const removeData = state.ui.remove.orchestrator
  return {
    isRemoveActive: removeData.get('isActive'),
    isLoggedIn: state.domain.user.token !== '',
    items: data.get('items').toArray(),
    error: data.get('error'),
    isSearching: data.get('isSearching'),
    isDirty: data.get('isDirty'),
    offset: data.get('offset'),
    limit: data.get('limit'),
    expectMore: data.get('expectMore'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    initialSearch: () => dispatch(headerActions.initialSearch()),
    search: () => dispatch(headerActions.searchMore()),
    goTo: url => dispatch(push(url)),
    setOpenShare: open => dispatch(shareActions.setOpen(open)),
    openLogin: () => dispatch(loginActions.open()),
    startDeposit: () => dispatch(depositActions.start()),
    setOffset: offset => dispatch(actions.setOffset(offset)),
    setLimit: limit => dispatch(actions.setLimit(limit)),
    addItem: (item) => dispatch(rentActions.addItem(item)),
    openCosts: () => dispatch(costsActions.setOpen(true)),
    getCosts: () => dispatch(costsActions.fetch()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/sections/yours/containers/yours.js